module.exports = __webpack_public_path__ + "static/media/hero.42324524.svg";